module.exports = __webpack_public_path__ + "static/helpful-1ed05f2d971f9391c9c6f51532a33455.svg";